import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, LOCALE_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly localeId: string | null = inject(LOCALE_ID, { optional: true });

  accessEnv$: BehaviorSubject<string> = new BehaviorSubject('');

  getConfig(objectsArray: object[] = [], populate: boolean = false) {
    let headers = new HttpHeaders({
      'Accept': 'application/json',
      'populate': populate.toString()
    });
    let queryString: string = '';
    if (objectsArray) {
      queryString = objectsArray.length > 0 ? '?' : '';
      objectsArray.forEach((query) => queryString += query['key'] + '=' + query['value']);
    }
    return this.http.get<any>('/develop/v1/environments' + queryString, { headers });
  }

  getPublicSettings() {
    return this.http.get<any>('/develop/v1/environments/public');
  }

  newEnvironments(body: any) {
    return this.http.post<any>('/develop/v1/environments', body, {});
  }

  putConfig(id: string, body: any) {
    return this.http.put(`/develop/v1/environments/${id}`, body, {});
  }

  deleteEnvironmentById(id: string) {
    return this.http.delete<any>(`/develop/v1/environments/${id}`, {});
  }

  getAccessEnv() {
    let access = this.http.get('/public_develop/v1/access/env', {});

    return access;
  }

  getCurrentAccessLanguage(): 'it' | 'en' {
    const locale = (this.localeId || '').toLowerCase();
    if (locale.startsWith('en')) {
      return 'en';
    }
    if (locale.startsWith('it')) {
      return 'it';
    }

    const firstSegment = ((globalThis.location?.pathname || '').split('/').find(Boolean) || '').toLowerCase();
    if (firstSegment === 'en' || firstSegment === 'it') {
      return firstSegment;
    }

    const htmlLang = (globalThis.document?.documentElement?.lang || '').toLowerCase();
    if (htmlLang.startsWith('en')) {
      return 'en';
    }
    if (htmlLang.startsWith('it')) {
      return 'it';
    }

    return 'it';
  }

  normalizeAccessEndpoint(accessEndpoint?: string, fallbackBaseUrl?: string): string {
    const accessPath = '/access';
    const accessValue = accessEndpoint ? accessEndpoint.trim() : '';
    const fallbackValue = fallbackBaseUrl ? fallbackBaseUrl.trim() : '';

    const tryBuildUrl = (value: string, base?: string): URL | null => {
      try {
        return base ? new URL(value, base) : new URL(value);
      } catch {
        return null;
      }
    };

    let parsedUrl = tryBuildUrl(accessValue);

    if (!parsedUrl && accessValue) {
      const baseForRelative =
        tryBuildUrl(fallbackValue) ||
        tryBuildUrl(globalThis.location?.origin || '');
      parsedUrl = baseForRelative
        ? tryBuildUrl(accessValue, baseForRelative.origin)
        : null;
    }

    if (!parsedUrl) {
      const fallbackBase =
        tryBuildUrl(fallbackValue) ||
        tryBuildUrl(globalThis.location?.origin || '') ||
        tryBuildUrl('https://pay.worldlineitalia.it');

      return new URL(accessPath, fallbackBase.origin).toString();
    }

    if (parsedUrl.pathname === '/access/') {
      parsedUrl.pathname = accessPath;
    }

    return parsedUrl.toString();
  }

}
